export const RESPONSE_STATUS = {
  requestPending: "pending",
  requestFullfilled: "fullfilled",
  requestRejected: "rejected",
};

export const CONSTANTS = {
  lead360CacheName: "lead360Cache",
};

export const timezones = [
  {
    label: 'IST - (GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi',
    value: 'India Standard Time$Asia/Kolkata',
  },
  {
    label: 'SMST - (GMT-11:00) Midway Island, Samoa',
    value: 'Samoa Standard Time$Pacific/Samoa',
  },
  {
    label: 'HAST - (GMT-10:00) Hawaii',
    value: 'Hawaiian Standard Time$US/Hawaii',
  },
  {
    label: 'AK - (GMT-09:00) Alaska',
    value: 'Alaskan Standard Time$US/Alaska',
  },
  {
    label: 'PT - (GMT-08:00) Pacific Time (US and Canada), Tijuana',
    value: 'Pacific Standard Time$US/Pacific',
  },
  {
    label: 'MST - (GMT-07:00) Arizona',
    value: 'US Mountain Standard Time$US/Arizona',
  },
  {
    label: 'MSTM - (GMT-07:00) Chihuahua, La Paz, Mazatlan',
    value: 'Mountain Standard Time (Mexico)$Canada/Mountain',
  },
  {
    label: 'MT - (GMT-07:00) Mountain Time (US and Canada)',
    value: 'Mountain Standard Time$US/Mountain',
  },
  {
    label: 'CST - (GMT-06:00) Guadalajara, Mexico City, Monterrey',
    value: 'Central Standard Time (Mexico)$America/Mexico_City',
  },
  {
    label: 'CT - (GMT-06:00) Central Time (US and Canada)',
    value: 'Central Standard Time$US/Central',
  },
  {
    label: 'CAST - (GMT-06:00) Central America',
    value: 'Central America Standard Time$America/Guatemala',
  },
  {
    label: 'CCST - (GMT-06:00) Saskatchewan',
    value: 'Canada Central Standard Time$Canada/Saskatchewan',
  },
  {
    label: 'EST - (GMT-05:00) Indiana (East)',
    value: 'US Eastern Standard Time$US/East-Indiana',
  },
  {
    label: 'SAPST - (GMT-05:00) Bogota, Lima, Quito',
    value: 'SA Pacific Standard Time$America/Bogota',
  },
  {
    label: 'ET - (GMT-05:00) Eastern Time (US and Canada)',
    value: 'Eastern Standard Time$US/Eastern',
  },
  {
    label: 'CBST - (GMT-04:00) Manaus',
    value: 'Central Brazilian Standard Time$America/Manaus',
  },
  {
    label: 'SAWST - (GMT-04:00) Caracas, La Paz',
    value: 'SA Western Standard Time$America/Caracas',
  },
  {
    label: 'PSAST - (GMT-04:00) Santiago',
    value: 'Pacific SA Standard Time$America/Santiago',
  },
  {
    label: 'AST - (GMT-04:00) Atlantic Time (Canada)',
    value: 'Atlantic Standard Time$Canada/Atlantic',
  },
  {
    label: 'NST - (GMT-03:30) Newfoundland and Labrador',
    value: 'Newfoundland Standard Time$Canada/Newfoundland',
  },
  {
    label: 'SAEST - (GMT-03:00) Buenos Aires, Georgetown',
    value: 'SA Eastern Standard Time$America/Argentina/Buenos_Aires',
  },
  {
    label: 'GNST - (GMT-03:00) Greenland',
    value: 'Greenland Standard Time$America/Godthab',
  },
  {
    label: 'ESAST - (GMT-03:00) Brasilia',
    value: 'E. South America Standard Time$America/Bahia',
  },
  {
    label: 'UTC02 - (GMT-02:00) Mid-Atlantic',
    value: 'Mid-Atlantic Standard Time$Etc/GMT-2',
  },
  {
    label: 'CVT - (GMT-01:00) Cape Verde Islands',
    value: 'Cape Verde Standard Time$Atlantic/Cape_Verde',
  },
  {
    label: 'AZOST - (GMT-01:00) Azores',
    value: 'Azores Standard Time$Atlantic/Azores',
  },
  {
    label: 'GST - (GMT-00:00) Casablanca, Monrovia',
    value: 'Greenwich Standard Time$Africa/Casablanca',
  },
  {
    label:
      'GMT - (GMT-00:00) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London',
    value: 'GMT Standard Time$Europe/London',
  },
  {
    label: 'WET - (GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna',
    value: 'W. Europe Standard Time$Europe/Amsterdam',
  },
  {
    label: 'ECT - (GMT+01:00) West Central Africa',
    value: 'W. Central Africa Standard Time$Africa/Algiers',
  },
  {
    label: 'RST - (GMT+01:00) Brussels, Copenhagen, Madrid, Paris',
    value: 'Romance Standard Time$Europe/Brussels',
  },
  {
    label: 'CEST - (GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb',
    value: 'Central European Standard Time$Europe/Sarajevo',
  },
  {
    label:
      'CET - (GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague',
    value: 'Central Europe Standard Time$Europe/Belgrade',
  },
  {
    label: 'NMST - (GMT+02:00) Windhoek',
    value: 'Namibia Standard Time$Africa/Windhoek',
  },
  {
    label: 'SAST - (GMT+02:00) Harare, Pretoria',
    value: 'South Africa Standard Time$Africa/Harare',
  },
  {
    label: 'ISST - (GMT+02:00) Jerusalem',
    value: 'Israel Standard Time$Asia/Jerusalem',
  },
  {
    label: 'GTBST - (GMT+02:00) Athens, Bucharest, Istanbul',
    value: 'GTB Standard Time$Europe/Athens',
  },
  {
    label: 'EET - (GMT+02:00) Helsinki, Kiev, Riga, Sofia, Tallinn, Vilnius',
    value: 'FLE Standard Time$Europe/Kiev',
  },
  {
    label: 'EGST - (GMT+02:00) Cairo',
    value: 'Egypt Standard Time$Egypt',
  },
  {
    label: 'EEST - (GMT+02:00) Minsk',
    value: 'E. Europe Standard Time$Europe/Minsk',
  },
  {
    label: 'MSK - (GMT+03:00) Moscow, St. Petersburg, Volgograd',
    value: 'Russian Standard Time$Europe/Moscow',
  },
  {
    label: 'EAT - (GMT+03:00) Nairobi',
    value: 'E. Africa Standard Time$Africa/Nairobi',
  },
  {
    label: 'ARST - (GMT+03:00) Baghdad',
    value: 'Arabic Standard Time$Asia/Baghdad',
  },
  {
    label: 'ABST - (GMT+03:00) Kuwait, Riyadh',
    value: 'Arab Standard Time$Asia/Kuwait',
  },
  {
    label: 'IRST - (GMT+03:30) Tehran',
    value: 'Iran Standard Time$Asia/Tehran',
  },
  {
    label: 'GET - (GMT+04:00) Tblisi',
    value: 'Georgian Standard Time$Asia/Tbilisi',
  },
  {
    label: 'AZT - (GMT+04:00) Baku',
    value: 'Azerbaijan Standard Time$Asia/Baku',
  },
  {
    label: 'AMT - (GMT+04:00) Yerevan',
    value: 'Caucasus Standard Time$Asia/Yerevan',
  },
  {
    label: 'ARBST - (GMT+04:00) Abu Dhabi, Muscat',
    value: 'Arabian Standard Time$Asia/Muscat',
  },
  {
    label: 'AFT - (GMT+04:30) Kabul',
    value: 'Afghanistan Standard Time$Asia/Kabul',
  },
  {
    label: 'WAST - (GMT+05:00) Islamabad, Karachi, Tashkent',
    value: 'West Asia Standard Time$Asia/Karachi',
  },
  {
    label: 'YEKT - (GMT+05:00) Ekaterinburg',
    value: 'Ekaterinburg Standard Time$Asia/Yekaterinburg',
  },
  {
    label: 'IST - (GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi',
    value: 'India Standard Time$Asia/Kolkata',
  },
  {
    label: 'NPT - (GMT+05:45) Kathmandu',
    value: 'Nepal Standard Time$Asia/Katmandu',
  },
  {
    label: 'SLT - (GMT+06:00) Sri Jayawardenepura',
    value: 'Sri Lanka Standard Time$Asia/Colombo',
  },
  {
    label: 'NCAST - (GMT+06:00) Almaty, Novosibirsk',
    value: 'N. Central Asia Standard Time$Asia/Almaty',
  },
  {
    label: 'BTT - (GMT+06:00) Astana, Dhaka',
    value: 'Central Asia Standard Time$Asia/Dhaka',
  },
  {
    label: 'MYST - (GMT+06:30) Yangon (Rangoon)',
    value: 'Myanmar Standard Time$Asia/Rangoon',
  },
  {
    label: 'THA - (GMT+07:00) Bangkok, Hanoi, Jakarta',
    value: 'SE Asia Standard Time$Asia/Bangkok',
  },
  {
    label: 'KRAT - (GMT+07:00) Krasnoyarsk',
    value: 'North Asia Standard Time$Asia/Krasnoyarsk',
  },
  {
    label: 'AWST - (GMT+08:00) Perth',
    value: 'W. Australia Standard Time$Australia/Perth',
  },
  {
    label: 'TIST - (GMT+08:00) Taipei',
    value: 'Taipei Standard Time$Asia/Taipei',
  },
  {
    label: 'SNST - (GMT+08:00) Kuala Lumpur, Singapore',
    value: 'Singapore Standard Time$Asia/Singapore',
  },
  {
    label: 'IRKT - (GMT+08:00) Irkutsk, Ulaanbaatar',
    value: 'North Asia East Standard Time$Asia/Irkutsk',
  },
  {
    label: 'CST - (GMT+08:00) Beijing, Chongqing, Hong Kong SAR, Urumqi',
    value: 'China Standard Time$Asia/Chongqing',
  },
  {
    label: 'YAKT - (GMT+09:00) Yakutsk',
    value: 'Yakutsk Standard Time$Asia/Yakutsk',
  },
  {
    label: 'TST - (GMT+09:00) Osaka, Sapporo, Tokyo',
    value: 'Tokyo Standard Time$Asia/Tokyo',
  },
  {
    label: 'KST - (GMT+09:00) Seoul',
    value: 'Korea Standard Time$Asia/Seoul',
  },
  {
    label: 'CAUST - (GMT+09:30) Adelaide',
    value: 'Cen. Australia Standard Time$Australia/Adelaide',
  },
  {
    label: 'ACST - (GMT+09:30) Darwin',
    value: 'AUS Central Standard Time$Australia/Darwin',
  },
  {
    label: 'WPST - (GMT+10:00) Guam, Port Moresby',
    value: 'West Pacific Standard Time$Pacific/Guam',
  },
  {
    label: 'VLAT - (GMT+10:00) Vladivostok',
    value: 'Vladivostok Standard Time$Asia/Vladivostok',
  },
  {
    label: 'TAST - (GMT+10:00) Hobart',
    value: 'Tasmania Standard Time$Australia/Hobart',
  },
  {
    label: 'EAST - (GMT+10:00) Brisbane',
    value: 'E. Australia Standard Time$Australia/Brisbane',
  },
  {
    label: 'AEST - (GMT+10:00) Canberra, Melbourne, Sydney',
    value: 'AUS Eastern Standard Time$Australia/Canberra',
  },
  {
    label: 'SBT - (GMT+11:00) Magadan, Solomon Islands, New Caledonia',
    value: 'Central Pacific Standard Time$Asia/Magadan',
  },
  {
    label: 'NZST - (GMT+12:00) Auckland, Wellington',
    value: 'New Zealand Standard Time$Pacific/Auckland',
  },
  {
    label: 'FJT - (GMT+12:00) Fiji Islands, Kamchatka, Marshall Islands',
    value: 'Fiji Standard Time$Pacific/Fiji',
  },
  {
    label: "PHOT - (GMT+13:00) Nuku'alofa",
    value: 'Tonga Standard Time$Pacific/Tongatapu',
  },
];  

export const widgetTypes = {
  ACTIVITES: "activities",
  TASKS: "tasks",
  OPPORTUNITIES: "opportunities",
  ABOUT: "about",
  NOTES: "notes",
  DOCUMENTS: "documents",
  CUSTOM_WIDGET: "customwidget",
};

export const tabTypes = {
  [widgetTypes.ABOUT]: "leadDetails",
  [widgetTypes.NOTES]: "LeadNotes",
  [widgetTypes.DOCUMENTS]: "leaddocumentsSummary",
  [widgetTypes.ACTIVITES]: "leadActivityHistory",
  [widgetTypes.OPPORTUNITIES]: "leadOpportunities",
  [widgetTypes.TASKS]: "tasksAndNotes",
  [widgetTypes.CUSTOM_WIDGET]: "leadCustomWidget",
};
